import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {IPosition} from "@/entity/position/position.types";

@Module({
    namespaced: true,
    name: 'position',
    store,
    dynamic: true,
})
class PositionModule extends VuexModule {
    position: IPosition[] = [];
    positionLoaded = false;

    @MutationAction
    async fetchAll(): Promise<{ position: IPosition[]; positionLoaded: boolean }> {
        const position = await store.$repository.position.fetchAll();
        let positionLoaded = false;
        if (position.length > 0) {
            positionLoaded = true;
        }
        return {position, positionLoaded};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        const resp = await store.$repository.position.delete({id: id});
        return resp;
    }
}

export const PositionStore = getModule(PositionModule);
